// Animate
const obs = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        let lastDelay = 0;

        entry.target
          .querySelectorAll(".element-animate")
          .forEach((section, index) => {
            section.style.transitionDelay = `${0.2 * index}s`;
            lastDelay = `${0.4 * index}`;

            section.classList.add("element-animate--done");
          });

        // entry.target.querySelectorAll(".cover").forEach((el, index) => {
        //   el.classList.add("cover--animate");
        //   el.style.animationDelay = lastDelay;

        //   const hiddenElement = entry.target.querySelector(".opacity-0");

        //   if (hiddenElement) {
        //     hiddenElement.style.transitionDelay = "1.2s";
        //     hiddenElement.classList.remove("opacity-0");
        //   }
        // });

        observer.unobserve(entry.target);
      }
    });
  },
  { rootMargin: "-25%" }
);

document.querySelectorAll(".section-animate").forEach((el) => {
  obs.observe(el);
});
